<script>
export default {
    data() {
        return {
            domains: []
        }
    },
    methods: {
        addDomain() {
            this.domains.push('');
        },
        updateDomain(event) {
            console.log(event);
            this.domains[event.index] = event.item;
        },
        removeDomain(event) {
            this.domains.splice(event.index, 1);
        }
    }
}
</script>
